"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Dropdown: function() {
        return Dropdown;
    },
    DropdownContext: function() {
        return DropdownContext;
    }
});
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _reactdom = require("@floating-ui/react-dom");
const _useFloatingHideListeners = require("../../hooks/useFloatingHideListeners");
const _NavContext = require("../../contexts/NavContext");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const DropdownContext = /*#__PURE__*/ _react.default.createContext({
    show: true,
    placement: "bottom-start",
    setToggleId: ()=>undefined,
    setShow: ()=>undefined,
    onSelect: ()=>undefined,
    onClose: ()=>undefined,
    autoClose: ()=>undefined,
    subscribe: ()=>()=>undefined,
    floating: ()=>undefined,
    middlewareData: {},
    reference: ()=>undefined,
    refs: {
        floating: {
            current: null
        },
        reference: {
            current: null
        }
    },
    strategy: "absolute",
    update: ()=>undefined,
    x: null,
    y: null
});
const Dropdown = (param)=>{
    let { children, placement = "bottom-start", flip = false, onSelect = ()=>undefined, onToggle = ()=>undefined, onAutoClose = ()=>undefined, onClose = ()=>undefined, fontWeight = "light", sameWidth = false, offset, strategy } = param;
    const [show, setShow] = (0, _react.useState)(false);
    const [toggleId, setToggleId] = (0, _react.useState)();
    const [subscribers, setSubscribers] = (0, _react.useState)({
        show: [],
        hide: []
    });
    (0, _react.useEffect)(()=>{
        onToggle(show);
    }, [
        show,
        onToggle
    ]);
    const floating = (0, _reactdom.useFloating)({
        strategy,
        placement,
        middleware: [
            (0, _reactdom.shift)(),
            ...flip ? [
                (0, _reactdom.flip)()
            ] : [],
            ...offset != null ? [
                (0, _reactdom.offset)(offset)
            ] : [],
            ...sameWidth ? [
                (0, _reactdom.size)({
                    apply (param) {
                        let { rects, elements } = param;
                        Object.assign(elements.floating.style, {
                            width: "".concat(rects.reference.width, "px")
                        });
                    }
                })
            ] : []
        ],
        whileElementsMounted: _reactdom.autoUpdate
    });
    (0, _react.useEffect)(()=>{
        if (show) {
            subscribers.show.forEach((callback)=>callback());
        }
    }, [
        show,
        subscribers
    ]);
    const onHide = ()=>{
        if (subscribers.hide.length > 0) {
            subscribers.hide.forEach((callback)=>callback());
        } else {
            setShow(false);
            onClose();
        }
    };
    (0, _useFloatingHideListeners.useFloatingHideListeners)({
        onHide,
        floating
    });
    const subscribe = (id, callback)=>{
        setSubscribers((prev)=>({
                ...prev,
                [id]: [
                    ...prev[id],
                    callback
                ]
            }));
        return ()=>{
            setSubscribers((prev)=>({
                    ...prev,
                    [id]: prev[id].filter((cb)=>cb !== callback)
                }));
        };
    };
    const autoClose = ()=>{
        setShow(false);
        onClose();
        onAutoClose();
    };
    return /*#__PURE__*/ _react.default.createElement(DropdownContext.Provider, {
        value: {
            show,
            toggleId,
            setToggleId,
            setShow,
            onSelect,
            onClose,
            autoClose,
            subscribe,
            ...floating
        }
    }, /*#__PURE__*/ _react.default.createElement(_NavContext.NavContext.Provider, {
        value: {
            fontWeight
        }
    }, children));
};

//# sourceMappingURL=Dropdown.js.map